import React from "react";
import { Typography } from "@mui/material";

interface SubscriberStatusProps {
  status?: string;
}

function SubscriberStatus(props: SubscriberStatusProps) {
  const { status } = props;

  if (!status) {
    return null;
  }

  if (status === "Unsubscribed") {
    return (
      <Typography variant="h4" color="error">
        {status}
      </Typography>
    );
  }

  if (status === "Subscribed") {
    return (
      <Typography variant="h4" color="primary">
        {status}
      </Typography>
    );
  }

  return (
    <Typography variant="h4" color="grey">
      {status}
    </Typography>
  );
}

export default SubscriberStatus;
